var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 23,
    fill: "#B03E2B",
    stroke: "white",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.0001,
    cy: 24.0001,
    r: 13.0909,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6931 28.4339L24.0004 25.0965L27.3076 28.4339L27.3772 28.5041L27.4482 28.4353L28.4336 27.4808L28.5062 27.4104L28.435 27.3386L25.1265 23.9999L28.435 20.6612L28.5062 20.5893L28.4336 20.519L27.4482 19.5644L27.3772 19.4956L27.3076 19.5658L24.0004 22.9033L20.6931 19.5658L20.6235 19.4956L20.5525 19.5644L19.5671 20.519L19.4945 20.5893L19.5657 20.6612L22.8742 23.9999L19.5657 27.3386L19.4945 27.4104L19.5671 27.4808L20.5525 28.4353L20.6235 28.5041L20.6931 28.4339Z",
    fill: "#B03E2B",
    stroke: "#B03E2B",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/Error.47acbc8d28dcba929a616d716cb2f281.svg";
export { ForwardRef as ReactComponent };